// utilities/cases-service.js
import { getToken } from "./users-service"; // ensure this exists in your project

// ---- keep your existing helper unchanged ----
export default async function sendRequest(url, method = "GET", payload = null) {

  
  const token = getToken();



  const headers = {};
  if (payload) headers["Content-Type"] = "application/json";
  if (token) headers.Authorization = `Bearer ${token}`;

  const options = { method, headers };
  if (payload) options.body = JSON.stringify(payload);

  const res = await fetch(url, options);

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`${res.status} ${res.statusText} - ${text}`);
  }

  return res.json();
}

// ---- convenience API wrappers you can import elsewhere ----

/** Fetch a case by id */
export async function getCase(caseId) {
  return sendRequest(`/api/cases/${caseId}`, "GET");
}

/**
 * Submit a ranking response for a given phase.
 * @param {string} caseId
 * @param {{
 *   phase: "submissionOne"|"submissionTwo"|"submissionThree"|
 *          "submissionFour"|"submissionFive"|"submissionSix",
 *   rankings: Array<{label:string, rank:number}>,
 *   questionsUsed?: number,
 *   interactions?: any[],        // or object, depending on your log shape
 *   rationale?: string,
 *   score?: number,
 *   priorResponses?: string[]
 * }} payload
 */
export async function sendResponse(caseId, payload) {
  // Backend route is singular: /response (NOT /responses)
  return sendRequest(`/api/cases/${caseId}/response`, "POST", payload);
}

/** Optional: a tiny helper if you like calling with just phase+array */
export async function submitRankings(caseId, phase, orderedLabels) {
  const rankings = orderedLabels.map((label, idx) => ({ label, rank: idx + 1 }));
  return sendResponse(caseId, { phase, rankings });
}

/**
 * Submit the final survey (after submissionSix).
 * @param {string} caseId
 * @param {{ ratingOne:number, ratingTwo:number, reflection:string }} payload
 */
export async function sendSurvey(caseId, payload) {
  return sendRequest(`/api/cases/${caseId}/survey`, "POST", payload);
}
